import React, { Component } from "react";

import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  Row,
  Col
} from "react-bootstrap";

import Header from "./header";
import TurnosCalendar from "./turnosCalendar";
import Configuracion from "./configuracion";
import Auth from "../containers/Auth";

// Globalize.locale("en");

class Turnos extends Component {
  state = {};

  constructor(props) {
    super(props);
    this.state = {
      professionalId: "",
      professionalName: "",
      config: false,
      token: null,
      expirationDate: null,
      isAuthenticated: false
    };
  }

  componentDidMount() {
    this.authCheckState();
  }

  authCheckState = () => {
    const token = localStorage.getItem("turnosToken");
    if (!token) {
      return;
    } else {
      const expirationDate = new Date(
        localStorage.getItem("turnosExpirationDate")
      );
      if (expirationDate > new Date()) {
        this.onLogin(token, expirationDate);
        this.checkAuthTimeOut(
          (expirationDate.getTime() - new Date().getTime()) / 1000
        );
      } else {
        this.onLogOut();
      }
    }
  };

  checkAuthTimeOut = expirationTime => {
    setTimeout(() => {
      this.onLogOut();
    }, expirationTime * 1000);
  };

  onChangeProfessional = (professionalId, professionalName) => {
    console.log("onChangeProfessional " + professionalName);
    this.setState({
      professionalId: professionalId,
      professionalName: professionalName
    });
    //this.getTurnos(this.state.currentDate, professionalId);
  };

  onGoConfig = () => {
    this.setState({ config: true });
  };

  onGoCalendar = () => {
    this.setState({ config: false });
  };

  onLogin = (token, expirationDate) => {
    this.setState({ token: token, expirationDate: expirationDate });
  };

  onLogOut = () => {
    this.setState({
      token: null,
      expirationDate: null,
      isAuthenticated: false
    });
    localStorage.removeItem("turnosToken");
    localStorage.removeItem("turnosExpirationDate");
  };

  render() {
    let profName = null;
    if (this.state.token !== null) {
      profName = (
        <div style={{ textAlign: "center" }}>
          <h3>{this.state.professionalName}</h3>
        </div>
      );
    }
    return (
      <React.Fragment>
        <Header
          onChangeProfessional={this.onChangeProfessional}
          onGoConfig={this.onGoConfig}
          onGoCalendar={this.onGoCalendar}
          token={this.state.token}
        />
        {profName}
        {this.state.token !== null ? (
          this.state.config ? (
            <Configuracion
              professionalId={this.state.professionalId}
              token={this.state.token}
            />
          ) : (
            <TurnosCalendar
              professionalId={this.state.professionalId}
              professionalName={this.state.professionalName}
              token={this.state.token}
            />
          )
        ) : (
          <Auth OnLoginSucess={this.onLogin} />
        )}
      </React.Fragment>
    );
  }
}

export default Turnos;



// WEBPACK FOOTER //
// ./src/components/turnos.jsx